/* eslint-disable function-paren-newline */ "use strict";
var body = document.body;
// Функція для повідомлень
function showMessage(text, type) {
    var div = document.createElement("div");
    div.dataset.qa = "notification";
    div.textContent = text;
    div.classList.add(type);
    body.append(div);
}
// --- First Promise ---
var firstPromise = new Promise(function(resolve, reject) {
    var onClick = function(e) {
        if (e.button === 0) {
            // тільки ліва кнопка
            cleanup();
            resolve("First promise was resolved");
        }
    };
    var timeoutId = setTimeout(function() {
        cleanup();
        // eslint-disable-next-line prefer-promise-reject-errors
        reject("First promise was rejected");
    }, 3000);
    var cleanup = function() {
        document.removeEventListener("mousedown", onClick);
        clearTimeout(timeoutId);
    };
    document.addEventListener("mousedown", onClick);
});
// --- Second Promise ---
var secondPromise = new Promise(function(resolve) {
    var handler = function(e) {
        if (e.button === 0 || e.button === 2) {
            document.removeEventListener("mousedown", handler);
            resolve("Second promise was resolved");
        }
    };
    document.addEventListener("mousedown", handler);
});
// --- Third Promise ---
var thirdPromise = new Promise(function(resolve) {
    var left = false;
    var right = false;
    var handler = function(e) {
        if (e.button === 0) left = true;
        if (e.button === 2) right = true;
        if (left && right) {
            document.removeEventListener("mousedown", handler);
            resolve("Third promise was resolved");
        }
    };
    document.addEventListener("mousedown", handler);
});
// --- Запуск і показ повідомлень ---
[
    firstPromise,
    secondPromise,
    thirdPromise
].forEach(function(p) {
    p.then(function(msg) {
        return showMessage(msg, "success");
    }).catch(function(msg) {
        return showMessage(msg, "error");
    });
});

//# sourceMappingURL=index.5e7ceb07.js.map
